import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
var _IconClose;
// TODO rrigoni Filename must match the exported name
// eslint-disable-next-line filenames/match-exported
import React from 'react';
import { createRegisteredContext } from 'react-singleton-context';
import { useIntl } from '@lumahealthhq/ui-components';
import { IconButton, IconClose, Slide, Snackbar, Typography } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TYPOGRAPHY_COLOR = {
  info: 'text.primary',
  warning: 'secondary.main',
  error: 'error.main',
  success: 'text.primary'
};
export var SnackbarContext = createRegisteredContext('SnackbarContext', undefined);
SnackbarContext.displayName = 'SnackbarContext';
function SlideTransition(props) {
  return /*#__PURE__*/_jsx(Slide, _extends({}, props, {
    direction: "up"
  }));
}
export default function SnackbarContextProvider(_ref) {
  var customOnOpen = _ref.onOpen,
    children = _ref.children;
  var intl = useIntl();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    snackPack = _React$useState4[0],
    setSnackPack = _React$useState4[1];
  var _React$useState5 = React.useState(undefined),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    messageInfo = _React$useState6[0],
    setMessageInfo = _React$useState6[1];
  React.useEffect(function () {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo(_extends({}, snackPack[0]));
      setSnackPack(function (prev) {
        return prev.slice(1);
      });
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);
  var handleOpen = React.useCallback(function (_ref2) {
    var message = _ref2.message,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'info' : _ref2$variant;
    setSnackPack(function (prev) {
      return [].concat(_toConsumableArray(prev), [{
        message: message,
        key: new Date().getTime(),
        variant: variant
      }]);
    });
  }, []);
  var handleClose = React.useCallback(function (_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }, []);
  var handleExited = React.useCallback(function () {
    setMessageInfo(undefined);
  }, []);
  var value = React.useMemo(function () {
    return {
      onOpen: customOnOpen != null ? customOnOpen : handleOpen
    };
  }, [customOnOpen, handleOpen]);
  var message = React.useMemo(function () {
    return typeof (messageInfo == null ? void 0 : messageInfo.message) === 'string' ? /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      color: TYPOGRAPHY_COLOR[messageInfo.variant],
      children: messageInfo.message
    }) : messageInfo == null ? void 0 : messageInfo.message;
  }, [messageInfo == null ? void 0 : messageInfo.message, messageInfo == null ? void 0 : messageInfo.variant]);
  if (customOnOpen) {
    return /*#__PURE__*/_jsx(SnackbarContext.Provider, {
      value: value,
      children: children
    });
  }
  var positionSnackbar = {
    horizontal: (messageInfo == null ? void 0 : messageInfo.variant) === 'error' ? 'center' : 'left',
    vertical: 'bottom'
  };
  return /*#__PURE__*/_jsxs(SnackbarContext.Provider, {
    value: value,
    children: [/*#__PURE__*/_jsx(Snackbar, {
      sx: {
        '& > div': {
          backgroundColor: 'white',
          color: 'primary.dark'
        }
      },
      open: open,
      anchorOrigin: positionSnackbar,
      autoHideDuration: 6000,
      onClose: handleClose,
      TransitionProps: {
        onExited: handleExited
      },
      TransitionComponent: SlideTransition,
      message: message,
      action: /*#__PURE__*/_jsx(IconButton, {
        "aria-label": intl.formatMessage({
          id: "BSij1a",
          defaultMessage: [{
            "type": 0,
            "value": "close"
          }]
        }),
        color: "inherit",
        sx: {
          p: 0.5
        },
        onClick: handleClose,
        children: _IconClose || (_IconClose = /*#__PURE__*/_jsx(IconClose, {}))
      })
    }, messageInfo ? messageInfo.key : undefined), children]
  });
}